'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;
// import { asyncConnect } from 'redux-async-connect'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _ScreenedCompanies = require('./ScreenedCompanies.css');

var _ScreenedCompanies2 = _interopRequireDefault(_ScreenedCompanies);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _ = require('../');

var _reactSlidedown = require('react-slidedown');

var _search = require('redux/modules/search');

var searchActions = _interopRequireWildcard(_search);

var _lodash = require('lodash');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompanySectors = require('../../data/CompanySectors.json');
var CompanyLinks = require('../../data/CompanyLinks.json');

var ScreenedCompanies = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    result: state.company.result,
    searching: state.company.loading,
    searched: state.company.loaded,
    error: state.company.error
  };
}, searchActions), _dec2 = (0, _reactCssModules2.default)(_ScreenedCompanies2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ScreenedCompanies, _Component);

  function ScreenedCompanies(props) {
    (0, _classCallCheck3.default)(this, ScreenedCompanies);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ScreenedCompanies.__proto__ || (0, _getPrototypeOf2.default)(ScreenedCompanies)).call(this, props));

    _this.clickViewMore = function (lbl) {
      var stateLbl = 'viewMore' + lbl;
      var newState = {};
      newState[stateLbl] = !_this.state[stateLbl];
      _this.setState(newState);
    };

    _this.renderCompanies = function (companies, type) {
      var iconPo = require('../../../static/images/icn-po.svg');
      var iconPp = require('../../../static/images/icn-pp.svg');
      var iconRb = require('../../../static/images/icn-rb.svg');
      var iconTb = require('../../../static/images/icn-tb.svg');
      var iconBf = require('../../../static/images/icn-bf.svg');
      var iconSy = require('../../../static/images/icn-sy.svg');

      var iconPoO = require('../../../static/images/icn-po-o.svg');
      var iconPpO = require('../../../static/images/icn-pp-o.svg');
      var iconRbO = require('../../../static/images/icn-rb-o.svg');
      var iconTbO = require('../../../static/images/icn-tb-o.svg');
      var iconBfO = require('../../../static/images/icn-bf-o.svg');
      var iconSyO = require('../../../static/images/icn-sy-o.svg');

      var iconPoY = require('../../../static/images/icn-po-y.svg');
      var iconPpY = require('../../../static/images/icn-pp-y.svg');
      var iconRbY = require('../../../static/images/icn-rb-y.svg');
      var iconTbY = require('../../../static/images/icn-tb-y.svg');
      var iconBfY = require('../../../static/images/icn-bf-y.svg');
      var iconSyY = require('../../../static/images/icn-sy-y.svg');
      return (0, _lodash.chain)(companies)
      // .take(page*MaxPerPage)
      .map(function (holding, idx) {
        var flags = [];
        var c = CompanySectors.data[holding.company_id];
        if (type === 'producers') {
          if ((0, _lodash.includes)(c, 'is_sy_p')) {
            flags.push(['is_sy_p', iconSy, 'Soy producer']);
          }
          if ((0, _lodash.includes)(c, 'is_bf_p')) {
            flags.push(['is_bf_p', iconBf, 'Cattle producer']);
          }
          if ((0, _lodash.includes)(c, 'is_tb_p')) {
            flags.push(['is_tb_p', iconTb, 'Timber producer']);
          }
          if ((0, _lodash.includes)(c, 'is_rb_p')) {
            flags.push(['is_rb_p', iconRb, 'Rubber producer']);
          }
          if ((0, _lodash.includes)(c, 'is_pp_p')) {
            flags.push(['is_pp_p', iconPp, 'Paper/pulp producer']);
          }
          if ((0, _lodash.includes)(c, 'is_po_p')) {
            flags.push(['is_po_p', iconPo, 'Palm oil producer']);
          }
        }
        if (type === 'banks') {
          flags = [['is_sy_c', iconSyO, 'Soy financier'], ['is_bf_c', iconBfO, 'Cattle financier'], ['is_tb_c', iconTbO, 'Timber financier'], ['is_rb_c', iconRbO, 'Rubber financier'], ['is_pp_c', iconPpO, 'Paper/pulp financier'], ['is_po_c', iconPoO, 'Palm oil financier']];
        }
        if (type === 'consumers') {
          if ((0, _lodash.includes)(c, 'is_sy_c')) {
            flags.push(['is_sy_c', iconSyY, 'Soy major consumer brand']);
          }
          if ((0, _lodash.includes)(c, 'is_bf_c')) {
            flags.push(['is_bf_c', iconBfY, 'Cattle major consumer brand']);
          }
          if ((0, _lodash.includes)(c, 'is_tb_c')) {
            flags.push(['is_tb_c', iconTbY, 'Timber major consumer brand']);
          }
          if ((0, _lodash.includes)(c, 'is_rb_c')) {
            flags.push(['is_rb_c', iconRbY, 'Rubber major consumer brand']);
          }
          if ((0, _lodash.includes)(c, 'is_pp_c')) {
            flags.push(['is_pp_c', iconPpY, 'Paper/pulp major consumer brand']);
          }
          if ((0, _lodash.includes)(c, 'is_po_c')) {
            flags.push(['is_po_c', iconPoY, 'Palm oil major consumer brand']);
          }
        }
        var links = CompanyLinks.data[holding.company_id];
        var zsl_spott = links ? links.zsl_spott : '';
        var supply_change = links ? links.supply_change : '';
        var banktrack = links ? links.banktrack : '';
        var rspo = links ? links.rspo : '';
        var forest500 = links ? links.forest500 : '';
        var other_link = links ? links.other_link : '';
        var link_map = [[zsl_spott, 'ZSL SPOTT'], [supply_change, 'Supply Change'], [banktrack, 'BankTrack'], [rspo, 'RSPO'], [forest500, 'Forest500'], [other_link, 'Other']];

        return _react2.default.createElement(
          'tr',
          { key: 'to_' + idx },
          _react2.default.createElement(
            'td',
            null,
            _react2.default.createElement(
              _.CompanyProfileModal,
              { company_id: holding.company_id },
              holding.short_name
            )
          ),
          _react2.default.createElement(
            'td',
            null,
            _react2.default.createElement(
              'small',
              null,
              holding.primary_symbol
            )
          ),
          _react2.default.createElement(
            'td',
            null,
            _react2.default.createElement(
              'small',
              null,
              holding.legal_name
            )
          ),
          /* only display the flags for consumers and producers */
          type !== 'banks' ? _react2.default.createElement(
            'td',
            null,
            flags.length > 0 ? flags.map(function (flag) {
              return _react2.default.createElement('img', {
                styleName: 'detail-icon-holding',
                key: flag[0],
                src: flag[1],
                alt: flag[2],
                title: flag[2]
              });
            }) : null
          ) : null,
          _react2.default.createElement(
            'td',
            null,
            /* display any research links for the company  */
            link_map.map(function (e, i) {
              var has_link = e[0].length;
              if (has_link) {
                return _react2.default.createElement(
                  'div',
                  { key: i, styleName: 'research-link-div' },
                  _react2.default.createElement(
                    _.Link,
                    {
                      to: e[0],
                      title: e[1] + ': ' + holding.short_name,
                      xstrong: true
                    },
                    e[1],
                    _react2.default.createElement(_.LinkIcon, null)
                  )
                );
              } else {
                return null;
              }
            })
          )
        );
      }).value();
    };

    _this.state = {
      viewMoreProducers: false,
      viewMoreFinanciers: false,
      viewMoreConsumers: false
    };
    return _this;
  }

  (0, _createClass3.default)(ScreenedCompanies, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
      this.props.companies();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (props.result) {
        var producersCompanies = [];
        var financiersCompanies = [];
        var consumersCompanies = [];
        props.result.map(function (el) {
          if (el.is_po_producer) producersCompanies.push(el);
          if (el.is_po_financier) financiersCompanies.push(el);
          if (el.is_po_consumer) consumersCompanies.push(el);
          return false;
        });
        var _sorter = function _sorter(a, b) {
          var lbl = 'short_name';
          var a_s = a[lbl].toLowerCase();
          var b_s = b[lbl].toLowerCase();
          return a_s.localeCompare(b_s);
        };
        producersCompanies = producersCompanies.sort(_sorter);
        financiersCompanies = financiersCompanies.sort(_sorter);
        consumersCompanies = consumersCompanies.sort(_sorter);
        this.setState({
          producersCompanies: producersCompanies,
          financiersCompanies: financiersCompanies,
          consumersCompanies: consumersCompanies
        });
      }
    }

    // e.g. (producersCompanies, 'producers')

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (!this.props.result) {
        return _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(_reactLoader2.default, {
            options: { scale: 0.70, top: '4.0rem' },
            loaded: false
          })
        );
      }

      // else if ( this.props.result && (!this.props.result.fund || !this.props.result.shareClass) ) {
      //   this.context.router.push(config.routes.notFound)
      //   return (
      //     <div styleName='main'>
      //       <Loader
      //         options={{scale: 0.70, top:'2.0rem'}}
      //         loaded={ false }
      //       />
      //     </div>
      //   )
      // }

      var producersLabel = !this.state.viewMoreProducers ? 'View producers and traders' : 'Hide producers and traders';
      var financiersLabel = !this.state.viewMoreFinanciers ? 'View banks and lenders' : 'Hide banks and lenders';
      var consumersLabel = !this.state.viewMoreConsumers ? 'View major consumer brands' : 'Hide major consumer brands';
      // images
      var producersIcon = require('../../../static/images/icn-producers.svg');
      var financiersIcon = require('../../../static/images/icn-banks.svg');
      var consumersIcon = require('../../../static/images/icn-consumers.svg');

      return _react2.default.createElement(
        'div',
        { styleName: 'main-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'company-table-wrapper' },
          _react2.default.createElement(
            'div',
            { styleName: 'company-table-icon-wrap' },
            _react2.default.createElement('img', {
              styleName: 'company-table-icon',
              src: producersIcon,
              alt: 'Agricultural commodity producers and traders'
            }),
            _react2.default.createElement(
              'div',
              { styleName: 'company-table-title-p' },
              'Agricultural commodity producers and traders'
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'Companies that produce and trade palm oil, paper/pulp, rubber, timber, cattle, and soy, and have a past record or a significant risk of contributing to deforestation, land grabbing, and human rights abuses.'
          ),
          _react2.default.createElement(
            'button',
            {
              styleName: 'company-table-button-p',
              onClick: function onClick() {
                _this2.clickViewMore('Producers');
              },
              title: producersLabel
            },
            producersLabel,
            _react2.default.createElement(_.LinkIcon, {
              faclass: this.state.viewMoreProducers ? 'fa-angle-up' : 'fa-angle-down'
            })
          ),
          _react2.default.createElement(
            _reactSlidedown.SlideDown,
            null,
            this.state.viewMoreProducers ? _react2.default.createElement(
              'table',
              { styleName: 't-table' },
              _react2.default.createElement(
                'thead',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'th',
                    null,
                    'Company'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Symbol'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Legal name'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Deforestation risk categories'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Research links'
                  )
                )
              ),
              _react2.default.createElement(
                'tbody',
                null,
                this.renderCompanies(this.state.producersCompanies, 'producers')
              )
            ) : null
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'company-table-wrapper' },
          _react2.default.createElement(
            'div',
            { styleName: 'company-table-icon-wrap' },
            _react2.default.createElement('img', {
              styleName: 'company-table-icon',
              src: financiersIcon,
              alt: 'Banks and lenders'
            }),
            _react2.default.createElement(
              'div',
              { styleName: 'company-table-title-f' },
              'Banks and lenders'
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'Financial institutions directly and indirectly involved in underwriting and lending to deforestation-risk producers and traders. These are the publicly listed banks drawn from the platform ',
            _react2.default.createElement(
              _.Link,
              { to: _config2.default.links.fAndf, title: 'Forests & Finance', xstrong: true },
              'Forests & Finance'
            ),
            '.'
          ),
          _react2.default.createElement(
            'button',
            {
              styleName: 'company-table-button-f',
              onClick: function onClick() {
                _this2.clickViewMore('Financiers');
              },
              title: financiersLabel
            },
            financiersLabel,
            _react2.default.createElement(_.LinkIcon, {
              faclass: this.state.viewMoreFinanciers ? 'fa-angle-up' : 'fa-angle-down'
            })
          ),
          _react2.default.createElement(
            _reactSlidedown.SlideDown,
            null,
            this.state.viewMoreFinanciers ? _react2.default.createElement(
              'table',
              { styleName: 't-table' },
              _react2.default.createElement(
                'thead',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'th',
                    null,
                    'Company'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Symbol'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Legal name'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Research links'
                  )
                )
              ),
              _react2.default.createElement(
                'tbody',
                null,
                this.renderCompanies(this.state.financiersCompanies, 'banks')
              )
            ) : null
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'company-table-wrapper' },
          _react2.default.createElement(
            'div',
            { styleName: 'company-table-icon-wrap' },
            _react2.default.createElement('img', {
              styleName: 'company-table-icon',
              src: consumersIcon,
              alt: 'Major consumer brands'
            }),
            _react2.default.createElement(
              'div',
              { styleName: 'company-table-title-c' },
              'Major consumer brands'
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'Consumer goods retailers that source palm oil, paper/pulp, rubber, timber, cattle, and soy from deforestation-risk producers and traders and sell it to consumers worldwide.'
          ),
          _react2.default.createElement(
            'button',
            {
              styleName: 'company-table-button-c',
              onClick: function onClick() {
                _this2.clickViewMore('Consumers');
              },
              title: consumersLabel
            },
            consumersLabel,
            _react2.default.createElement(_.LinkIcon, {
              faclass: this.state.viewMoreConsumers ? 'fa-angle-up' : 'fa-angle-down'
            })
          ),
          _react2.default.createElement(
            _reactSlidedown.SlideDown,
            null,
            this.state.viewMoreConsumers ? _react2.default.createElement(
              'table',
              { styleName: 't-table' },
              _react2.default.createElement(
                'thead',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'th',
                    null,
                    'Company'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Symbol'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Legal name'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Deforestation risk categories'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Research links'
                  )
                )
              ),
              _react2.default.createElement(
                'tbody',
                null,
                this.renderCompanies(this.state.consumersCompanies, 'consumers')
              )
            ) : null
          )
        )
      );
    }
  }]);
  return ScreenedCompanies;
}(_react.Component), _class2.propTypes = {
  searching: _react.PropTypes.bool,
  searched: _react.PropTypes.bool,
  error: _react.PropTypes.object,
  result: _react.PropTypes.array
}, _temp)) || _class) || _class);
exports.default = ScreenedCompanies;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ScreenedCompanies/ScreenedCompanies.js
// module id = 1312
// module chunks = 0